import { gql } from '@apollo/client';
const MOVE_FOLDER = gql `
  mutation MoveFolder($folderToMoveId: ID!, $destinationFolderId: ID!) {
    moveModelSpecificationFolder(
      folderToMoveId: $folderToMoveId
      destinationFolderId: $destinationFolderId
    ) {
      modelSpecificationFolder {
        id
        parentFolder {
          id
        }
      }
    }
  }
`;
export default MOVE_FOLDER;
